import { Component, OnInit } from '@angular/core';
import { ServiceService } from '../service.service';

@Component({
  selector: 'app-product-compliant',
  templateUrl: './product-compliant.component.html',
  styleUrls: ['./product-compliant.component.css']
})
export class ProductCompliantComponent implements OnInit {

  constructor(private productService:ServiceService) { }

  //complaintUrl='http://192.241.151.66:5000/viewProducts//product_list/product_complaints'
  output:any=[]
  ngOnInit(): void {
    this.productService.GetProductComplaintList("").subscribe((res)=>{
      this.output=res.data
  
      })
  }

}
